import { fmtCurrency, fmtNumber } from '../../format.js';

export default function FileInsights({ insights, newBrands, newChannels }) {
  if (!insights) return null;
  const stat = (label, value) => (
    <div style={{ minWidth: 130 }}>
      <div style={{ fontSize: 10, color: '#8C94A0', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 14, fontWeight: 600 }}>{value}</div>
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', marginBottom: 14 }}>
        {stat('Rows imported', fmtNumber(insights.row_count))}
        {stat('Advertisers', (insights.advertisers || []).length)}
        {stat('Channels', (insights.channels || []).length)}
        {stat('Date range', insights.date_min && insights.date_max ? `${insights.date_min} → ${insights.date_max}` : '—')}
        {stat('Total budget', fmtCurrency(insights.total_budget))}
        {stat('Rows skipped', fmtNumber(insights.blank_value_rows || 0))}
      </div>

      {(newBrands?.length > 0 || newChannels?.length > 0) && (
        <div style={{ background: '#F5EEDF', border: '1px solid #8C6A2F', borderRadius: 8, padding: 12, marginBottom: 12, fontSize: 12 }}>
          <div style={{ color: '#A4560E', fontWeight: 600, marginBottom: 6 }}>New values detected — not seen in prior imports for this client</div>
          {newBrands?.length > 0 && <div style={{ marginBottom: 4 }}><b>Advertisers:</b> {newBrands.join(', ')}</div>}
          {newChannels?.length > 0 && <div><b>Channels:</b> {newChannels.join(', ')}</div>}
        </div>
      )}

      {insights.errors?.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <div style={{ color: '#A4560E', fontSize: 12, marginBottom: 4 }}>{insights.errors.length} row(s) skipped:</div>
          <ul style={{ margin: 0, paddingLeft: 18, color: '#8C94A0', fontSize: 11, maxHeight: 140, overflowY: 'auto' }}>
            {insights.errors.map((e, i) => <li key={i}>{e}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
